/**
 * List of URL substrings that should not trigger a retry after a 401 error.
 * Cloud auth endpoints plus local device endpoints so device 401s are passed
 * to localReq for the unlock modal instead of triggering token refresh + retry.
 */
export const NON_RETRYABLE_URLS = [
	'/v2/users/auth',
	'/user/delete_user',
	'/auth/complete_unit_transfer_registration',
	'/auth/decline_unit_transfer',
	'/rpc/',
	'/status',
	'/shelly',
	'/settings',
	'/power-prices/selectra/',
];
